import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CentralPipe } from './central.pipe';
import { TelaPrincipalComponent } from './tela-principal/tela-principal.component';
import { RouterModule, Routes } from '@angular/router';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FormsModule } from '@angular/forms';
import { MenuCombustiveisComponent } from './menu-combustiveis/menu-combustiveis.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ForceCursorEndDirective } from './central.directive';

export const routes: Routes = [
  { path: '', component: TelaPrincipalComponent },

];


@NgModule({
  declarations: [
    CentralPipe,
    TelaPrincipalComponent,
    MenuCombustiveisComponent,
    ForceCursorEndDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(routes),
    CurrencyMaskModule,
  ]

})
export class CentralAjustePrecosModule { }
